import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const ErrorModal = styled.div`
  display: flex;
  padding: 40px 50px;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px;
  }
`;

export const Title = styled(Typography.Header)`
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

export const Message = styled(Typography.Caption)`
  font-size: 16px;
  text-align: center;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
    margin-bottom: 20px;
  }
`;
